import React from 'react';
import clsx from 'clsx';

import styles from './Brand.module.scss';
import { BRAND_STYLE } from '../api/portletConfiguration';
import { BRAND_STYLES } from '../utils/Constants';
import { isBrandLabel } from '../api/brandUtil';

export default function Brand({ variant, content, img }) {
	const _isBrandLabel = isBrandLabel(content, img);

	return img ? (
		<img
			className={clsx(styles.root)}
			src={img}
			alt={'Immagine di ' + content}
		/>
	) : (
		<span
			className={clsx(
				styles.root,
				styles[variant],
				_isBrandLabel ? styles.label : null
			)}
		>
			{content}
		</span>
	);
}
